import { action } from 'satcheljs/lib/legacy';
import { TableView } from 'owa-mail-list-store';

// Clear lastEmptiedTime on tableView
// This fixes issues where items are prevented from updating since lastEmptiedTime
// is set but never removed after EmptyFolder is completed. Easily seen when emptying
// DeletedItems then deleting items from another folder (DeletedItems will no longer update)
// since lastEmptiedTime is more recent than item lastDelivery and will result in
// shouldSkipProcessRow returning true.
export default action('clearTableViewLastEmptiedTime')(function clearTableViewLastEmptiedTime(
    tableView: TableView
) {
    tableView.lastEmptiedTime = null;
});
